//JS STUFF
document.addEventListener('DOMContentLoaded', function () {
  // const layout_switcher = document.getElementById('layout-switch');
  const layout_switcher = document.getElementsByName('layout-switch');
  const container = document.getElementById('locations--supervisory');
  const delay = 150;
  const STORAGE_KEY = 'layout';
  const GRID_CLASS = '--grid';
  const LIST_CLASS = '--list';

  // Load saved layout 
  const layout = localStorage.getItem(STORAGE_KEY) || 'grid';
  const isList = layout === 'list';
  if (container && layout_switcher) {
    container.classList.toggle(GRID_CLASS, !isList);
    container.classList.toggle(LIST_CLASS, isList);
    layout_switcher.forEach(radio => {
      radio.checked = false;
      if (layout == radio.id) radio.checked = true;
    });
  }

  if (layout_switcher && container) {
    layout_switcher.forEach(item => {
      item.addEventListener('change', e => {
        const isList = e.target.id === 'list';
        container.classList.add('fadeOut');
        setTimeout(function () {
          container.classList.toggle(GRID_CLASS, !isList);
          container.classList.toggle(LIST_CLASS, isList);
          localStorage.setItem(STORAGE_KEY, isList ? 'list' : 'grid');
          container.classList.remove('fadeOut');
        }, delay)
      });
    }) 
  }

//split icao into each character
document.querySelectorAll('.info__icao').forEach(el => {
  el.innerHTML = splitIcaoCharacters(el.textContent.trim());
});


const hero_gallery_ele = document.getElementById('location-media-gallery');
const gallery_cta = document.getElementById('gallery__cta');
let lgInstance = null;

if (hero_gallery_ele) {
  function createPlaceholder(hasIcon = true) {
    const icon = (hasIcon) ? `<span class="gallery-video-placeholder__icon"><i class="fa-sharp fa-light fa-film-slash"></i></span>` : '';
    return `<div class="gallery-video-placeholder">${icon}Please allow <a href="javascript:Cookiebot.renew()" class="cookiebot-banner-toggler lg-video-placeholder__cta color-red">marketing cookies</a> to view video content.</div>`;
  }

  function hasMarketingConsent() {
    return window.Cookiebot && Cookiebot.consent && Cookiebot.consent.marketing
  }

  function getDynamicItems() {
    return gallery_media.map(function (media) {
      //video allowed
      if (media.type === "video") {
        return {
          src: hasMarketingConsent() ? media.src : media.blockedThumbnail,
          thumb: hasMarketingConsent() ? media.thumb : media.blockedThumbnail,
          poster: hasMarketingConsent() ? media.poster : '',
          subHtml: hasMarketingConsent() ? media.subHtml : createPlaceholder(false)
        }
      } else {
        return {
          src: media.src,
          thumb: media.thumb,
          subHtml: media.subHtml
        }
      }
    });
  }

  function renderThumbs() {
    hero_gallery_ele.innerHTML = '';
    gallery_media.forEach(function (item, index) {
      const el = document.createElement('a');
      el.className = 'gallery-media --' + item.type;
      el.dataset.index = String(index);
      el.setAttribute('href', '#');

      if (item.type === 'video') {
        el.classList.add('ratio');
        el.classList.add('ratio-16x9');
      }

      if (item.type === 'video' && !hasMarketingConsent()) {
        el.classList.add('marketing-consent--blocked');
        el.dataset.src = item.blockedThumbnail;

        el.innerHTML = `${createPlaceholder()}`;
      } else {
        el.innerHTML = `
            <img src="${item.thumb}" alt="${item.subHtml}">
            ${item.type === 'video' ? '<span class="media-thumb__play" aria-hidden="true"><i class="fa-sharp fa-solid fa-play"></i></span>' : ''}
          `;
      }

      el.addEventListener('click', function (e) {
        e.preventDefault();
        let _target = e.currentTarget;
        if (_target.classList.contains('marketing-consent--blocked')) {
          Cookiebot.renew();
        } else {
          if (!lgInstance) return;
          lgInstance.openGallery(index);
        }
      });
      hero_gallery_ele.appendChild(el);
      hero_gallery_ele.classList.remove('loading');
      if (gallery_cta) {
        gallery_cta.classList.remove('d-none');
        gallery_cta.addEventListener('click', function () {
          if (!lgInstance || lgInstance.galleryItems < 1) return;
          lgInstance.openGallery(0);
        });
      }
    })
  }

  hero_gallery_ele.addEventListener('lgBeforeOpen', function (e) {
    document.querySelector('.lg-content').style.top = 0;
  });
  // hero_gallery_ele.addEventListener('lgBeforeClose', function(e) {
  //   document.body.classList.remove('menu-open');
  // });

  function initializeGallery(items) {
    lgInstance = lightGallery(hero_gallery_ele, {
      licenseKey: 'LIG-C8B0919B-F014-41FE-8E0D-E69533EF93C7',
      autoplayFirstVideo: false,
      autoplayVideoOnSlide: false,
      backdropDuration: 200,
      download: false,
      dynamic: true,
      dynamicEl: items,
      enableSwipe: items.length > 1,
      enableDrag: items.length > 1,
      hideScrollbar: true,
      mobileSettings: {
        controls: true,
        showCloseIcon: true,
      },
      plugins: [lgThumbnail, lgVideo],
      selector: '.gallery-media',
      startAnimationDuration: 200,
      strings: {
        closeGallery: 'Close Gallery'
      },
      subHtmlSelectorRelative: true,
      videoMaxSize: "1920-1080",
      vimeoPlayerParams: {
        autoplay: 0,
      },
      youtubePlayerParams: {
        autoplay: 0,
        modestbranding: 1,
      },
      zoomFromOrigin: false,
    });
  }

  function syncGalleryItems() {
    const newItems = getDynamicItems();
    //reinit
    if (!lgInstance) {
      initializeGallery(newItems);
    } else {
      //if it's open
      if (lgInstance.lgOpened) {
        const currentIndex = parseInt(lgInstance.index);
        lgInstance.updateSlides(newItems, currentIndex);
        setTimeout(() => {
          lgInstance.slide(currentIndex);
        }, 50);
      } else {
        lgInstance.refresh(newItems);
      }
    }
    return;
  }

  function syncGalleryState() {
    renderThumbs();
    syncGalleryItems();
  }

  syncGalleryState();

  window.addEventListener('CookiebotOnConsentReady', syncGalleryState, false);
  window.addEventListener('CookiebotOnAccept', syncGalleryState, false);
  window.addEventListener('CookiebotOnDecline', syncGalleryState, false);

  // if(gallery_cta) {
  //   gallery_cta.addEventListener('click', function() {
  //     if (!lgInstance || lgInstance.galleryItems < 1) return;
  //     lgInstance.openGallery(0);
  //   });
  // }

  //play button click
  document.addEventListener('click', function (e) {
    if (hasMarketingConsent() && e.target.closest('.lg-video-play-button')) {
      setTimeout(function () {
        let iframe = e.target.closest('.lg-video-play-button').nextElementSibling;
        if (iframe && iframe.hasAttribute('data-cookieblock-src')) {
          const url = iframe.dataset.cookieblockSrc;
          iframe.removeAttribute('data-cookieblock-src');
          iframe.removeAttribute('data-cookieconsent');
          iframe.src = '';
          setTimeout(function () {
            const currentSlide = document.querySelector('.lg-video-loading');
            if (currentSlide) currentSlide.classList.add('lg-video-loaded');
            iframe.src = url.replace('autoplay=0', 'autoplay=1');
          }, 50);
        }
      }, 100)
    }
  });
}

//trigger UA agent modal with query
const page = document.querySelector('.--vip-ground-supervision');
if (page) {
  const params = new URLSearchParams(window.location.search);
  const profile = params.get('agent');
  if (profile) {
    const modalId = `modal-bio-${profile}`;
    // optional: check if modal exists before opening
    if (document.getElementById(modalId)) {
      MicroModal.show(modalId, {
        disableScroll: true
      });
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }
}
// const ditty = document.querySelector('.ditty');
// if (ditty) {
//   const observer = new MutationObserver((mutations, obs) => {
//     if (ditty.querySelector('.ditty-item')) {
//       obs.disconnect();
//       const news_wrapper = document.querySelector('#news-wrapper');
//       const swiper_wrapper = news_wrapper.querySelector('.swiper-wrapper');
//       const ditty_list = document.querySelector('.ditty-list__page');
//       var ditty_items = ditty_list.querySelectorAll('.ditty-item');
//       if(ditty_items) {
//         ditty_items.forEach((item, index) => {
//           item.classList.add('swiper-slide');
//           swiper_wrapper.appendChild(item);
//         });
//         setTimeout(() => {
//           const news_tickers = new Swiper('#news-wrapper', {
//             loop: true,
//             effect: 'fade',
//             fadeEffect: {
//               crossFade: true
//             },
//             pagination: {
//               el: '.news__swiper-pagination',
//               clickable: false,
//               type: 'fraction' //'progressbar' | 'bullets' | 'fraction' | 'custom'
//             },
//             navigation: {
//               nextEl: '.news-button--next',
//               prevEl: '.news-button--prev',
//             }
//           });
//         }, 100);
//       }
//     }
//   });
//   observer.observe(ditty, {
//     childList: true,
//     subtree: true
//   });
// }

//POPOVERS
const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
popoverTriggerList.forEach(trigger => new bootstrap.Popover(trigger));
// const popoverList = [...popoverTriggerList].map(popoverTriggerEl => {
//   const popover = new bootstrap.Popover(popoverTriggerEl);
//   popoverTriggerEl.addEventListener('shown.bs.popover', () => {
//     popover.tip.addEventListener('click', ()=>{
//       popover.hide()
//     })
//   })
// });

// Close others when one is opened
popoverTriggerList.forEach(trigger => {
  trigger.addEventListener('show.bs.popover', function () {
    popoverTriggerList.forEach(otherTrigger => {
      if (otherTrigger !== trigger) {
        const instance = bootstrap.Popover.getInstance(otherTrigger);
        if (instance) instance.hide();
      }
    });
  });
});

//close popovers when clicking outside
document.addEventListener('click', function (e) {
  popoverTriggerList.forEach(trigger => {
    const popover = bootstrap.Popover.getInstance(trigger);
    if (!popover) return;
    const popoverEl = document.querySelector('.popover');
    const insideTrigger = trigger.contains(e.target);
    const insidePopover = popoverEl?.contains(e.target);
    if (!insideTrigger && !insidePopover) popover.hide();
  });
});

//Tooltips
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

const searchFormInput = document.querySelector('.orig');
const searchClearButton = document.querySelector('.search-clear-btn');
const searchModal = document.querySelector('#search-modal');
const searchForm = document.querySelector('#searchform');
function showClearButton() {
  searchClearButton.classList.add('show');
}
function hideClearButton() {
  if (searchClearButton) searchClearButton.classList.remove('show')
}
if (searchFormInput) {
  searchFormInput.addEventListener('input', (event) => {
    setTimeout(() => {
      if (event.target.value != null && event.target.value != '') showClearButton()
      else hideClearButton()
    }, 20)
  });
}

if (searchModal) {
  searchModal.addEventListener('hide.bs.modal', () => {
    hideClearButton();
    if (searchForm) searchForm.reset()
  })
  searchModal.addEventListener('shown.bs.modal', () => {
    searchFormInput.focus()
  })
}
if (searchForm) searchForm.addEventListener('reset', function () {
  hideClearButton()
});

    //Google Maps on supervisory locations
    // const location_map = document.getElementById("location_map");
    // (async () => {
    //   const { Map } = await google.maps.importLibrary("maps");
    //   const { Place } = await google.maps.importLibrary("places");
    //   const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    //   const map = new Map(location_map, {
    //     center: { lat: 0, lng: 0 },
    //     zoom: 15,
    //     mapId: "d9e05abfff80bf6afc0144dc"
    //   });

    //   // 🔑 Create Place from Place ID
    //   const place = new Place({
    //     id: location_map.dataset.placeId
    //   });

    //   // 🔥 Fetch the fields you need
    //   await place.fetchFields({
    //     fields: ["displayName", "formattedAddress", "location"]
    //   });

    //   if (!place.location) {
    //     console.error("No location found for this Place ID");
    //     return;
    //   }

    //   // ✅ Center map
    //   map.setCenter(place.location);

    //   // ✅ Add marker
    //   new AdvancedMarkerElement({
    //     map,
    //     position: place.location,
    //     title: place.displayName
    //   });

    //   // ✅ Output address
    //   document.getElementById("supervisory_address").innerHTML = `<span class="header">
    //     <span class="icon p-0 m-0"><i class="fa-sharp fa-light fa-map-location"></i></span>
    //   </span>
    //   <span class="wrapper">
    //     <span class="label">Address</span>
    //     <span class="value">${place.formattedAddress}</span>
    //   </span>`;

    //   //remove loading spinner
    //   location_map.classList.remove('loading');
    // })();


    //scrolling to section
    function scrollToSection(id, offset = 0) {
      // Validate ID
      if (typeof id !== 'string' || !id.trim()) {
        console.warn('scrollToSection: Invalid section ID.');
        return false;
      }

      // Find target (accepts "section" or "#section")
      const targetId = id.trim().replace(/^#/, '');
      const target = document.getElementById(targetId);

      if (!target) {
        console.warn(`scrollToSection: #${targetId} not found.`);
        return false;
      }

      // Validate offset
      const safeOffset = Number(offset);

      if (!Number.isFinite(safeOffset)) {
        console.warn('scrollToSection: Invalid offset.');
        return false;
      }

      // Calculate absolute scroll position
      const targetY =
        target.getBoundingClientRect().top +
        window.scrollY -
        safeOffset;

      // Clamp to available scroll range
      const maxScroll = Math.max(
        0,
        document.documentElement.scrollHeight - window.innerHeight
      );

      const scrollY = Math.max(0, Math.min(targetY, maxScroll));

      // Respect reduced-motion preferences
      const reduceMotion = window.matchMedia?.(
        '(prefers-reduced-motion: reduce)'
      ).matches ?? false;

      window.scrollTo({
        top: scrollY,
        behavior: reduceMotion ? 'instant' : 'smooth'
      });

      return true;
    }

  });

////////////////////////////////////////////////////////////////////////////
//jQuery STUFF
jQuery(function ($) {
  //search form
  // $('.probox form input.orig').on('focus', function(e) {
  //   $(this).closest('.ajaxsearchpro').addClass('focus');
  // });
  // $('.probox form input.orig').on('blur', function(e) {
  //   $(this).closest('.ajaxsearchpro').removeClass('focus');
  // });

  //initialize micromodal
  MicroModal.init({
    disableScroll: true,
    disableFocus: true,
    awaitCloseAnimation: true,
    awaitOpenAnimation: true,
    onShow: (modal) => {
      setTimeout(function () {
        const closeButton = modal.querySelector('.modal__close');
        if (closeButton) closeButton.focus();
      }, 10)
    },
    onClose: (modal) => {
      const wrapper = modal.querySelector('.modal__content');
      if (wrapper && !isDesktop()) wrapper.scrollTop = 0;

      //this applies to leadership modal only
      if (modal.classList.contains('leadership-modal') && !modal.classList.contains('vip-agents-modal') && !modal.classList.contains('location-manager-modal')) {
        //$('.modal__container,.modal__content').scrollTop(0);
        $('#modal__content__wrapper').html('');
        $('.modal__overlay').addClass('loading');
      }
    }
  });


  //back to top link
  $('.back-top-link').on('click', (e) => {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutQuint');
    return false;
  })


  //adding external links
  $('.footer-social').find('li > a').addClass('external-link');
  //or
  $('a').filter(function () {
    return (!this.parentElement.classList.contains('no-modal') && !this.classList.contains('no-modal') && (this.hostname && this.hostname !== location.hostname));
  }).addClass("external-link");

  $('.external-link').on('click', (e) => {
    e.preventDefault();
    let link = $(e.currentTarget).attr('href');
    let ext_modal = $('#modal-external');
    ext_modal.find('#proceed-button').attr({
      'href': link
    });
    setTimeout(function () {
      MicroModal.show('modal-external', {
        disableScroll: true,
      });
    }, 10);
  });


  //check if it's Desktop 
  function isDesktop() {
    return $(window).width() >= 992 ? true : false;
  }

  //escape key pressed
  $(document).keyup(function (e) {
    if (e.key === "Escape") { // escape key maps to keycode `27`
      if ($('.extra-menu').hasClass('show')) {
        hideExtramenu()
      }
      //closeOverlay();
    }
  });

  //setting header
  const siteHeader = $('.navbar');
  const scroll_threshold = 200;
  var scroll = 0;
  const search_modal = document.getElementById('search-modal');

  //focus on modal open
  if (search_modal) {
    search_modal.addEventListener('shown.bs.modal', event => {
      let search_input = search_modal.querySelector('.orig');
      if (search_input) search_input.focus();
    });
  }

  const header = document.querySelector('.site-header');
  const breadscrumb = document.querySelector('.section--breadscrumb ');
  const notification_bar = document.getElementById('notification-bar');
  const toggle_notification_button = document.querySelector('#toggle-notification');
  const section_hero = document.querySelector('.section--hero');
  const hero_section = document.querySelector('.hero-section');

  if (notification_bar) {
    toggle_notification_button.addEventListener('click', function () {
      this.setAttribute(
        'aria-expanded',
        this.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
      );
      this.setAttribute(
        'title',
        this.getAttribute('aria-expanded') === 'true' ? 'Hide alerts' : 'Show alerts'
      );
      this.textContent = this.getAttribute('aria-expanded') === 'true' ? 'Close' : 'Show Alerts';

      if (notification_bar.classList.contains('show')) hideNotificationBar()
      else showNotificationBar();

      setHeroSectionMargin();
    })

  }

  function hideNotificationBar() {
    if (notification_bar && notification_bar.classList.contains('show')) notification_bar.classList.remove('show');
    // if(breadscrumb) breadscrumb.style.removeProperty('margin-top');
    // else {
    //   if(section_hero) section_hero.style.removeProperty('margin-top');
    //   if(hero_section) hero_section.style.removeProperty('margin-top');
    // }
  }
  function showNotificationBar() {
    if (notification_bar && !notification_bar.classList.contains('show')) notification_bar.classList.add('show');
  }

  function setHeroSectionMargin() {
    let offset = header.offsetHeight - siteHeader.outerHeight();
    if (notification_bar) {
      if (isDesktop()) {
        if (breadscrumb) { //pages with breadcrumb as a light bar
          breadscrumb.style.setProperty(
            'margin-top',
            `${header.offsetHeight}px`
          );
        } else {
          if (section_hero) section_hero.style.setProperty(
            'margin-top',
            `${offset}px`);

          if (hero_section) hero_section.style.setProperty(
            'margin-top',
            `${offset}px`);
        }
      } else { //mobile
        if (breadscrumb) breadscrumb.style.removeProperty('margin-top');
        if (section_hero) section_hero.style.removeProperty('margin-top');
        if (hero_section) hero_section.style.removeProperty('margin-top');
      }
    }
  }

  function setSiteHeader(scroll) {
    //fail safe
    if (scroll == null || scroll == undefined) scroll = $(window).scrollTop();
    if (scroll >= scroll_threshold) {
      showSiteHeader();
      showTopLink();
      showLocationMenu();
    }
    else {
      hideSiteHeader();
      hideTopLink()
      hideLocationMenu()
    }
    //setting country map height
    setCountryMapHeight();
    return;
  }

  function setSearchModalVisibility() {
    if (search_modal) {
      const modal_ele = bootstrap.Modal.getInstance(search_modal); // Retrieves active instance
      if (!isDesktop() && search_modal.classList.contains('show')) {
        modal_ele.hide();
      }
    }
  }
  function setCountryMapHeight() {
    let map_height = 800;
    let map_container = null;

    map_container = document.querySelector('.coverage-map-container');

    if (map_container !== null) {
      let map = map_container.querySelector('#amchart1');
      if ($(window).width() <= 575) map_height = 320;
      if ($(window).width() >= 576 && $(window).width() <= 991) map_height = 500;
      if (map) map.style.height = map_height + 'px';
    }
    return;
  }
  function showSiteHeader() {
    if (!$('.navbar').hasClass("light")) siteHeader.addClass('scrolled');
    return;
  }
  function hideSiteHeader() {
    if (!$('.navbar').hasClass("light")) siteHeader.removeClass('scrolled');
    return;
  }
  function showLocationMenu() {
    if ($('.site-header').hasClass('--has-notification') && isDesktop()) {
      let offset_top = Math.floor($('.site-header').outerHeight());
      $('.section--global-ctas').css('transform', 'translateY(' + offset_top + 'px)');
    }
    $('.section--global-ctas').addClass('show');
  }
  function hideLocationMenu() {
    $('.section--global-ctas').removeClass('show');
  }

  function showTopLink() {
    $('.back-top-link').show();
  }
  function hideTopLink() {
    $('.back-top-link').hide();
  }

  //window scroll
  $(window).on("scroll", function () {
    scroll = $(window).scrollTop();
    setSiteHeader(scroll);
  });

  $(document).ready(function () {
    scroll = $(window).scrollTop();
    setTimeout(setSiteHeader, 100, scroll);

    //if site has notifications
    showNotificationBar();
    //set hero section margin
    setHeroSectionMargin();
  });

  $(window).on("resize", function () {
    scroll = $(window).scrollTop();
    setTimeout(setSiteHeader, 100, scroll);
    //search modal
    setTimeout(setSearchModalVisibility, 100);
    //set hero section margin
    setTimeout(setHeroSectionMargin, 50);
  });


  //HERO SLIDER
  var isPause = false; //is the slider paused?
  var rtime = 6; //number of seconds to change the slide
  var percentTime = 0, tick;
  var $rbar = $('.progress-circle circle');
  var rlen = 2 * Math.PI * $rbar.attr('r');

  //loading circle functions
  function startProgressbar() {
    if (!isPause) tick = setInterval(interval, 10, rtime);
  }
  function interval(time) {
    percentTime += 1 / (time + 0.1);
    $rbar.css({
      'stroke': '#222',
      'stroke-width': 2,
      'stroke-dasharray': rlen,
      'stroke-dashoffset': rlen * (1 - percentTime / 100)
    });
    if (percentTime >= 100) {
      resetProgressbar();
      hero_slider.slideNext();
    }
  }
  function resetProgressbar() {
    $rbar.css({
      'stroke-width': 0,
      'stroke-dasharray': 0,
      'stroke-dashoffset': 0
    });
    clearTimeout(tick);
    percentTime = 0;
  }


  // Homepage slider
  const hero_slider = new Swiper('.hero-slider', {
    loop: true,
    speed: 600,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'fraction' //'progressbar' | 'bullets' | 'fraction' | 'custom'
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    //events
    on: {
      init: () => resetProgressbar(),
      afterInit: () => startProgressbar(),
      slideChangeTransitionStart: () => { if (!isPause) resetProgressbar() },
      slideChangeTransitionEnd: () => startProgressbar(),
    }
  });

  $('#home-slider-pause').on('click', function (e) {
    if (isPause == false) {
      isPause = true;
      clearInterval(tick);
    } else {
      isPause = false;
      startProgressbar();
    }
    $(this).attr('data-is-paused', isPause);
    $(this).attr('title', isPause ? "Start slider autoplay" : "Pause slider autoplay");
  });

  //news updates ticker slider
  const progressCircle = document.querySelector('.autoplay-progress svg');
  const autoplayButton = document.querySelector('.autoplay-progress');
  if ($('#news-wrapper').hasClass('swiper')) {
    const news_tickers = new Swiper('#news-wrapper', {
      loop: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      effect: 'fade',
      watchOverflow: true,
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.news__swiper-pagination',
        type: 'fraction', //'progressbar' | 'bullets' | 'fraction' | 'custom'
      },
      navigation: {
        nextEl: '.news-button--next',
        prevEl: '.news-button--prev',
      },
      //the autoplay progress
      on: {
        autoplayTimeLeft(s, time, progress) {
          progressCircle.style.setProperty('--progress', 1 - progress);
          //progressContent.textContent = `${Math.ceil(time / 1000)}s`;
        },
      },
    });

    autoplayButton.addEventListener('click', function (e) {
      let label = this.ariaLabel === 'Pause' ? 'Play' : 'Pause';
      if (this.ariaLabel === 'Pause') {
        news_tickers.autoplay.stop();
        this.title = 'Play news ticker';
      }
      else {
        news_tickers.autoplay.start();
        this.title = 'Pause news ticker';
      }
      this.ariaLabel = label;
    })
  }

  //Press Releases Slider
  const press_release_slider = new Swiper('.featured-press-release-wrapper', {
    loop: true,
    speed: 500,
    effect: 'fade',
    autoHeight: true,
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  //featured post slider
  const featured_post_slider = new Swiper('#featured-post-slider', {
    loop: true,
    speed: 500,
    effect: 'fade',
    autoHeight: true,
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets' //'progressbar' | 'bullets' | 'fraction' | 'custom'
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  //our brand slider
  var brand_sliders = [];
  $('.brand__image-slider').each(function (index) {
    brand_sliders[index] = new Swiper('#' + $(this).attr('id'), {
      loop: true,
      speed: 500,
      // effect: 'fade',
      autoHeight: true,
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.swiper-pagination-' + (index + 1),
        clickable: true,
        type: 'bullets' //'progressbar' | 'bullets' | 'fraction' | 'custom'
      },
      navigation: {
        nextEl: '.swiper-button-next-' + (index + 1),
        prevEl: '.swiper-button-prev-' + (index + 1),
      }
    });
  })



  //related posts
  const related_posts_slider = new Swiper('#related-post-slider', {
    loop: false,
    slidesPerView: 2,
    slidesPerGroup: 3,
    spaceBetween: 20,
    speed: 500,
    breakpoints: {
      992: {
        slidesPerView: 3.5,
        slidesPerGroup: 4
      },
      1200: {
        slidesPerView: 3.5,
        slidesPerGroup: 4
      },
      1440: {
        slidesPerView: 4,
        slidesPerGroup: 4
      }
    },

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      type: "fraction",
    },

    // // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    // },
  });

  //blog footer slider
  const blog_footer_slider = new Swiper('#blog-footer-slider', {
    loop: false,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    speed: 500,
    watchOverflow: true,
    centerInsufficientSlides: true,
    breakpoints: {
      576: {
        watchOverflow: true,
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      992: {
        watchOverflow: true,
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    },

    // If we need pagination
    pagination: {
      el: '.blog__swiper-pagination',
      type: "bullets",
    },

    // // Navigation arrows
    navigation: {
      nextEl: '.blog__swiper-button-next',
      prevEl: '.blog__swiper-button-prev',
    },
  });


  //single location hero slider
  const single_location_slider = new Swiper('#location-slider', {
    loop: true,
    speed: 800,
    pagination: {
      el: '.hero-slider__swiper-pagination',
      clickable: true,
      type: 'bullets' //'progressbar' | 'bullets' | 'fraction' | 'custom'
    },
    navigation: {
      nextEl: '.hero-slider-button__next',
      prevEl: '.hero-slider-button__prev',
    }
  });

  //news ticker
  // function initializeNewsSlider() {
  //   const news_tickers = new Swiper('#news-wrapper', {
  //     loop: true,
  //     effect: 'fade',
  //     fadeEffect: {
  //       crossFade: true
  //     },
  //     pagination: {
  //       el: '.news__swiper-pagination',
  //       clickable: false,
  //       type: 'fraction' //'progressbar' | 'bullets' | 'fraction' | 'custom'
  //     },
  //     navigation: {
  //       nextEl: '.news-button--next',
  //       prevEl: '.news-button--prev',
  //     }
  //   });
  // }

  //news ticker
  // setTimeout(()=>{
  //   const ditty_list = $('.ditty-list__page');
  //   var tickers = ditty_list.find('.ditty-item');
  //   const swiper_wrapper = $('#news-wrapper').find('.swiper-wrapper');
  //   if(tickers.length > 0) {
  //     tickers.each(function() {
  //       $(this).addClass('swiper-slide');
  //       swiper_wrapper.append($(this));
  //     });
  //     setTimeout(initializeNewsSlider, 100);
  //   }
  // }, 1000);

  //guides by country scroll to section
  function getElementOffsetFromPageTop(element) {
    const rect = element.getBoundingClientRect();
    return rect.top + window.scrollY;
  }
  const guide_by_country = document.querySelector('#guides-by-country');
  if (guide_by_country) {
    var guides = guide_by_country.querySelectorAll('.accordion-collapse');
    if (guides) {
      guides.forEach((currentItem, index) => {
        currentItem.addEventListener('shown.bs.collapse', function (event) {
          const offsetTop = getElementOffsetFromPageTop(event.currentTarget);
          $("html, body").animate({ scrollTop: offsetTop - (isDesktop() ? 130 : siteHeader.outerHeight()) }, 500, 'easeOutQuint');
        })
      });
    }
  }

  $('.team-bio-trigger').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    $this.prop('disabled', 'disabled');
    var post_id = $this.data("post_id");
    var nonce = $this.data('nonce');
    if ($('.leadership-modal').hasClass('is-open'))
      load_leadership_bio(post_id, nonce);
    else {
      $('#modal__content__wrapper').html('');
    }
  });

  function load_leadership_bio(id, nonce) {
    var content = '';
    jQuery.ajax({
      type: "GET",
      dataType: "json",
      url: location_filter_obj.ajaxurl,
      timeout: 7000,
      retryLimit: 3,
      data: {
        action: "load_bio",
        post_id: id,
        nonce: nonce
      },
      beforeSend: function (xhr) {
        $('#modal__content__wrapper').html('').hide();
        $('.modal__overlay').addClass('loading');
      },
      success: function (response, status, xhr) {
        if (status == 'success') {
          var profile = response['content'].length > 0 ? response['content'] : '<p>Bio coming soon.</p>';
          //header
          content += '<div class="wrapper__image" style="background-image: url(' + response['image'] + ')">';
          content += '<img class="d-block d-lg-none" src="' + response['image'] + '" alt="' + response['name'] + '">';
          content += '</div>';
          //bio
          content += '<div class="wrapper__bio">';
          content += '<div class="header__right pt-2 pb-4 mb-4"><h3 class="name">' + response['name'] + '</h3>';
          content += '<p class="mb-0 mt-2 title">' + response['title'] + '</p></div>';
          content += profile;
          content += '</div>';
        }
        else content = '<p>There was an error loading biography. Please try again.</p>';
        $('#modal__content__wrapper').html(content);
      },
      complete(xhr, status) {
        $('#modal__content__wrapper').show();
        $('.modal__overlay').removeClass('loading');
      },
      error: function (XMLHttpRequest, textStatus, errorThrown) {
        if (textStatus == 'timeout') {
          this.retryLimit--;
          if (this.retryLimit) {
            $.ajax(this);
            return;
          }
          return;
        }
        if (xhr.status == 500) {
          content = 'There was a server error. Please try again later.';
          $('#modal__content__wrapper').html(content).show();
        }
      }
    });
  }


  //local time ticker
  function startLocalClock(lat, lng, el) {
    const timezone = tzlookup(lat, lng);
    const tick = () => {
      const now = moment().tz(timezone);
      el.textContent = now.format("dddd hh:mm A");
    };
    tick();
    return setInterval(tick, 1000);
  }

  var local_time_tickers = document.querySelectorAll(".local-time-ticker");
  var time_lat = '', time_lon = '';
  if (local_time_tickers) {
    local_time_tickers.forEach((ele, ind) => {
      if (ind == 0) {
        time_lat = parseFloat(ele.dataset.lat);
        time_lon = parseFloat(ele.dataset.lon);
      }
      if (time_lat != null && time_lon != null) startLocalClock(time_lat, time_lon, ele);
    });
  }


  //vip agents slider
  const vip_agents_slider = new Swiper('#vip-agents-slider', {
    speed: 500,
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 15,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        spaceBetween: 20,
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      992: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      1400: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      }
    }
  });

  /*
  //old: scroll to footnotes when clicking on ua-tooltip
  $('.ua-addinfo').on('click', function(){
    var footnotes = $('.footnotes');

    if(footnotes.length > 0) {
      $('html, body').animate({ 
        scrollTop: footnotes.offset().top - 150
      }, 800, 'easeInOutQuint');
    }
  });
  */


  //location highlights
  $('.location-highlights > ol > li, .location-highlights > ul > li').each(function (index, li) {
    $(this).contents().wrap('<span></span');
  });


  //hero text slider
  // const heroSlider = new Swiper('.hero-text-slider', {
  //   direction: 'vertical',
  //   loop: true,
  //   rewind: true,
  //   centeredSlides: true,
  //   slidesPerView: 5,
  //   spaceBetween: 60,
  //   allowTouchMove: false,
  //   speed: 500,
  //   autoplay: {
  //     delay: 2000,
  //     disableOnInteraction: false,
  //   },
  // });

  // const toggle = document.querySelector('.hero-greeting__toggle');

  // toggle.addEventListener('click', () => {
  //   if (heroSlider.autoplay.running) {
  //     heroSlider.autoplay.stop();

  //     toggle.textContent = 'Play';
  //     toggle.setAttribute('aria-label', 'Play greeting slider');
  //   } else {
  //     heroSlider.autoplay.start();

  //     toggle.textContent = 'Pause';
  //     toggle.setAttribute('aria-label', 'Pause greeting slider');
  //   }
  // });

}); //end jQuery
